<template>
  <b-row id="repairDetail">
    <b-col class="col-8">
      <Left v-if="detailLoaded" :detailInfo="detailInfo" @initDetailInfo="initDetailInfo"></Left>
    </b-col>
    <b-col class="col-4">
      <Right v-if="detailLoaded" :detailInfo="detailInfo" @initDetailInfo="initDetailInfo"></Right>
    </b-col>
  </b-row>
</template>

<script>
import Left from "./children/LeftInfo.vue";
import Right from "./children/RightInfo.vue";
import { getRepairDetail } from "@/service/index";

export default {
  data() {
    return {
      detailInfo: {},
      detailLoaded: false
    };
  },
  mounted() {
    this.initDetailInfo();
  },
  methods: {
    initDetailInfo() {
      this.detailLoaded = false
      let d_id = this.$route.params.id;
      getRepairDetail(d_id).then((res) => {
        if (res && res.payload) {
          this.detailInfo = res.payload;
          this.detailLoaded = true
        }
      });
    },
  },
  components: {
    Left,
    Right,
  },
};
</script>

<style scoped lang="scss">
#repairDetail {
  flex: 1;
  font-size: 14px;
}
</style>
